class GiftWrappingForm extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.checkbox = this.querySelector('[data-gift-wrap-checkbox]');
    this.variantId = this.dataset.giftWrapVariantId;
    
    if (this.checkbox && this.variantId) {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      this.syncWithForm();
    }
  }

  handleCheckboxChange() {
    this.syncWithForm();
  }

  syncWithForm() {
    this.classList.toggle('show', this.checkbox.checked);

    // Find the hidden inputs in the product form
    const variantInput = document.querySelector('[data-gift-wrap-variant-id]');
    const quantityInput = document.querySelector('[data-gift-wrap-quantity]');
    const propertyInput = document.querySelector('[data-custom-option-target="gift_wrapping"]');
    
    if (this.checkbox.checked) {
      // Set the variant ID and quantity for the gift wrap product
      if (variantInput) variantInput.value = this.variantId;
      if (quantityInput) quantityInput.value = '1';
      if (propertyInput) propertyInput.value = 'Yes';
    } else {
      // Clear the values
      if (variantInput) variantInput.value = '';
      if (quantityInput) quantityInput.value = '';
      if (propertyInput) propertyInput.value = '';
    }
  }
}

// Register the custom element
customElements.define('gift-wrapping-form', GiftWrappingForm);
